import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'
import {fetchByTag,setCopy} from './recipesSlice'
import GymMultiSelect from '../GymMultiSelect/GymMultiSelect'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const CopyModal = () => {
	const dispatch = useDispatch()
	const statusPost = useApiStatusEnvAwarePost()
	const { show, id } = useSelector( 
		state => state.recipes.copy 
	)
	const [selectedGyms, setSelectedGyms] = useState([])
	const [copyStatus, setCopyStatus] = useState('idle')
	const onHide = () => {
		setSelectedGyms([])
		dispatch(setCopy({ show: false, id: null }))
	}

	const handleCopy = () => {
		setCopyStatus('pending')
		const tgt_users = selectedGyms.map( 
			g => g.value 
		)
		statusPost('api/recipes/', {
			action: 'copyRecipes',
			recipe_id: id,
			tgt_users
		}, 'recipe', 'copi').then(res => {
			dispatch(fetchByTag({ action: 'readRecipes', tags: [], loadInBackground: true }))
			setCopyStatus('idle')
			setSelectedGyms([])
			onHide()
		})
	}
	
	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				Copy Recipe
			</Modal.Header>
			<Modal.Body className="mt-2">
				<GymMultiSelect
					disabled={copyStatus === 'pending'}
					onChange={setSelectedGyms}
				/>
				<Button
					disabled={copyStatus === 'pending'}
					onClick={handleCopy}
					variant="outline-success"
					className="mt-2"
					block
				>
					<span className="mr-1">Copy</span>
					{copyStatus === 'pending' && <Spinner size="sm" animation="border" />}
				</Button>
			</Modal.Body>
		</Modal>
	)
}


export default CopyModal